module.exports = __webpack_public_path__ + "img/32.81a1a84b.jpg";